var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6939 2.15669C21.6939 2.15669 21.6939 2.16607 21.6939 2.17075L16.2376 20.1651C16.155 20.4574 15.985 20.7174 15.7504 20.9103C15.5158 21.1032 15.2278 21.2197 14.9251 21.2442C14.882 21.2479 14.8389 21.2498 14.7957 21.2498C14.512 21.2507 14.234 21.1704 13.9945 21.0184C13.7549 20.8664 13.5639 20.6491 13.4439 20.392L10.0961 13.3242C10.063 13.2543 10.0524 13.1758 10.0656 13.0996C10.0789 13.0234 10.1154 12.9532 10.1701 12.8986L15.5382 7.5295C15.673 7.38771 15.747 7.19889 15.7444 7.00332C15.7419 6.80775 15.6631 6.6209 15.5248 6.4826C15.3865 6.34429 15.1997 6.26549 15.0041 6.26299C14.8085 6.26048 14.6197 6.33448 14.4779 6.46919L9.10137 11.8373C9.04672 11.892 8.97649 11.9285 8.90029 11.9418C8.82409 11.9551 8.74566 11.9444 8.67574 11.9114L1.64449 8.58044C1.36835 8.45393 1.13595 8.24831 0.97674 7.98963C0.817528 7.73095 0.738657 7.43085 0.750116 7.12732C0.765386 6.81535 0.878328 6.51607 1.07297 6.2718C1.26762 6.02752 1.53412 5.85061 1.8348 5.76607L19.8292 0.309817H19.8432C20.0994 0.237837 20.3702 0.235313 20.6277 0.302505C20.8852 0.369697 21.1202 0.504185 21.3085 0.692171C21.4969 0.880157 21.6319 1.11487 21.6996 1.37224C21.7673 1.6296 21.7653 1.90034 21.6939 2.15669Z",
    fill: "#DDE0E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.c9de63ae776e211e467fd77f544d6499.svg";
export { ForwardRef as ReactComponent };